/**
 * The relation types that make a customer the boat's owner (the seller).
 * `boat_customer.relation_type` is free text: the CMS has used "Verkäufer"
 * and "seller", and the office writes "Eigner" — which this left out, so
 * most owners did not show in the boat list.
 */
export const OWNER_RELATION_TYPES = ['Eigner', 'Verkäufer', 'seller', 'owner']

export const isOwnerRelation = (relationType?: string | null) =>
  OWNER_RELATION_TYPES.some((t) => t.toLowerCase() === (relationType ?? '').trim().toLowerCase())

export const boatSellers = (boat, source_field = 'boat_customer') => {
  return boat[source_field]
    ? boat[source_field].filter((customer) => isOwnerRelation(customer.relation_type))
    : []
}
